"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rpnCalc_1 = __importDefault(require("../lib/rpnCalc"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('C', (context, args) => {
    return rpnCalc_1.default(...args.map(v => {
        let n = parseFloat(v);
        if (isNaN(n))
            return v;
        else
            return n;
    }));
});
